import {FormControlLabel, Radio, RadioGroup} from '@mui/material';
import {useField, useFormikContext} from 'formik';
import {notEmpty} from 'main/utility/CommonUtil';
import PropTypes from 'prop-types';

const AppOptFldRadio = (props) => {
  const {options, optionalignment, labelid} = props;
  const [field] = useField(props);
  const {setFieldValue} = useFormikContext();
  const optionInRow = optionalignment !== 'vertical';

  const handleChange = (event) => {
    const newValue = event.target.value;
    setFieldValue(field.name, newValue);
  };

  return (
    <RadioGroup
      name={field.name}
      value={field.value}
      onChange={handleChange}
      row={optionInRow}
      aria-labelledby={labelid} // RadioGroup does not support labelId.
    >
      {notEmpty(options) &&
        options.map((option) => (
          <FormControlLabel
            key={`${field.name}:${option.value}`}
            value={option.value}
            label={option.label}
            control={<Radio />}
          />
        ))}
    </RadioGroup>
  );
};

AppOptFldRadio.propTypes = {
  name: PropTypes.string.isRequired,
  labelid: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      value: PropTypes.any.isRequired,
    }),
  ).isRequired,
  optionalignment: PropTypes.oneOf(['vertical', 'horizontal']),
};

export default AppOptFldRadio;
